import { DateRange } from "components/InputCalendar";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ICalendar } from "components/Calendar";
import { DivFilled, DivGrid } from "./styles";
import { IInputHookOut, InputLabel } from "components/Input";
import { IcoInfo, TitleH3, TitleH4 } from "components/generic";
import { InfoMessage } from "../RoomsDetails/styles";
import { FlexBox } from "components/containers";

export const AvailabilityPrice: React.FC<{
  dateIn: ICalendar;
  isAnyDateOut?: boolean;
  rentalError?: string;
  setIsAnyDateOut: (isAnyDate: boolean) => void;
  dateOut: ICalendar;
  roomPrice: IInputHookOut;
  deposit: IInputHookOut;
  additionalCosts: IInputHookOut;
  modeView?: string;
}> = ({ dateIn, dateOut, roomPrice, deposit, additionalCosts, setIsAnyDateOut, isAnyDateOut, rentalError, modeView }) => {
  const { t } = useTranslation("hostrooms");

  const [isDateInFirst, setIsDateInFirst] = useState<number>(0)

  useEffect(() => {
    if ((dateOut.value && dateIn.value) && (dateOut.value < dateIn.value)) {
      dateOut.onChange(undefined, undefined)
    }
  }, [dateOut.value, dateIn.value])

  return (
    <DivGrid>
      <div id="dateInAv">
        <TitleH3 style={{ margin: 0 }}>
          {`${t(`availabilityPrices.items.dateFrom.title`)}  `}
          <InfoMessage
            message={t("availabilityPrices.items.dateFrom.tooltip")}
            left="-6em"
          >
            <IcoInfo size="1em" />
          </InfoMessage>
        </TitleH3>
        <DateRange {...dateIn} setIsDateInFirst={setIsDateInFirst} isAnyDateIn={isAnyDateOut} modeView={modeView} rentalError={rentalError} rightBorder={isDateInFirst === 1 ? undefined : dateOut.value} isClose />
        <span style={{ color: 'red', wordBreak: 'break-word' }}>
          {/*//@ts-ignore*/}
          {rentalError?.includes(dateIn.value?.toISOString().slice(0, 10)) && t('rooms.errorPeriod', { date: dateIn.value.toISOString().slice(0, 10) })}
        </span>
      </div>
      <div>
        <DateRange
          isDateInFirst={isDateInFirst}
          rentalError={rentalError}
          modeView={modeView}
          leftBorder={dateIn.value}
          {...dateOut}
          anyEndDate
          isAnyDateOut={isAnyDateOut}
          setIsAnyDateOut={setIsAnyDateOut}
          title={t(`availabilityPrices.items.dateUntil.title`)}
          id="dateOutAv"
          isClose
        />
        <span style={{ color: 'red' }}>
          {/*//@ts-ignore*/}
          {(rentalError?.includes(dateOut.value?.toISOString().slice(0, 10)) && !isAnyDateOut) && `The date ${dateOut.value.toISOString().slice(0, 10)} includes the rental period`}
        </span>
      </div>
      <InputLabel
        {...roomPrice}
        prefix="€"
        type="number"
        title={t("availabilityPrices.items.roomPrice.title")}
        placeholder={t("availabilityPrices.items.roomPrice.placeholder")}
        id="roomPrice"
        min={0}
        onFocus={() => Number(roomPrice.value) === 0 && roomPrice.onChange("")}
      />
      <InputLabel
        {...deposit}
        prefix="€"
        type="number"
        title={t("availabilityPrices.items.deposit.title")}
        placeholder={t("availabilityPrices.items.roomPrice.placeholder")}
        id="deposit"
        min={0}
        onFocus={() => Number(deposit.value) === 0 && deposit.onChange("")}
      />
      <div id="additionalCosts">
        <TitleH3 style={{ margin: 0 }}>
          {`${t(`availabilityPrices.items.additionalCosts.title`)}  `}
          <InfoMessage
            left="-6em"
            message={t("availabilityPrices.items.additionalCosts.tooltip")}
          >
            <IcoInfo size="1em" />
          </InfoMessage>
        </TitleH3>

        <InputLabel
          {...additionalCosts}
          prefix="€"
          type="number"
          placeholder={t("availabilityPrices.items.roomPrice.placeholder")}
          min={0}
          p="4px 0 0 0"
          onFocus={() =>
            Number(additionalCosts.value) === 0 && additionalCosts.onChange("")
          }
        />
      </div>
      <DivFilled id="expectedIncome">
        <TitleH3>{t("availabilityPrices.expectedIncome.title")}</TitleH3>
        <FlexBox justify="space-between" width="232px" padding="8px 0 0 0">
          <TitleH4>{t("availabilityPrices.expectedIncome.roomPrice")}</TitleH4>
          <TitleH3 style={{ margin: 0 }}>{`€ ${roomPrice.value || 0}`}</TitleH3>
        </FlexBox>
        <FlexBox justify="space-between" width="232px" padding="0 0 8px 0">
          <TitleH4>
            {t("availabilityPrices.expectedIncome.additionalCosts")}
          </TitleH4>
          <TitleH3 style={{ margin: 0 }}>
            {`€ ${additionalCosts.value || 0}`}
          </TitleH3>
        </FlexBox>
        <hr style={{ width: "232px" }} />
        <FlexBox justify="space-between" width="232px" padding="8px 0 0 0">
          <TitleH4>{t("availabilityPrices.expectedIncome.perMonth")}</TitleH4>
          <TitleH3 style={{ margin: 0 }}>
            {`€ ${Number(roomPrice.value || 0) + Number(additionalCosts.value || 0)
              }`}
          </TitleH3>
        </FlexBox>
        <FlexBox justify="space-between" width="232px" padding="0 0 8px 0">
          <TitleH4>{t("availabilityPrices.expectedIncome.perYear")}</TitleH4>
          <TitleH3 style={{ margin: 0 }}>
            {`€ ${(Number(roomPrice.value || 0) +
              Number(additionalCosts.value || 0)) *
              12
              }`}
          </TitleH3>
        </FlexBox>
      </DivFilled>
    </DivGrid>
  );
};
